// extracted by mini-css-extract-plugin
module.exports = {"red":"_1AWutQs_kJTQ_qVbuHW0i2","blue":"_3HAgBlpPASwWBsBB6pXmqF","mono":"_3q9vgW30XgWa3IjiI0h6Vk","normal":"_3FKiVHOG2iEc0tiCaz7w87","green":"nPzUH4ujkBo6GeB9nGXG3"};